import type { CalculatedAttributeResolver } from '../../calculatedAttributes/resolve';
import { ATTR_NAMES } from '../../types/attrNames';
import type { CmsProduct } from '../../types/cmsProduct';
import type { BrandId } from '../override';

/**
 * The effective rate a rate cell stacks under ANNUAL_RATE (CMS-1921 R4,
 * CMS-1928 R3). SingSaver only: MoneyHero selects APR as its own column. Asked
 * of the block's own resolver, so both lines come from one batch.
 */
export const resolveStackedEffectiveRate = (
  attributeName: string | undefined,
  product: CmsProduct | undefined,
  brand: BrandId | undefined,
  resolveCalculated: CalculatedAttributeResolver,
): string | undefined => {
  if (attributeName !== ATTR_NAMES.ANNUAL_RATE || brand !== 'singsaver') {
    return undefined;
  }
  const resolved = resolveCalculated(ATTR_NAMES.APR, product);
  return resolved?.state === 'resolved' ? resolved.value.formatted : undefined;
};
